// import {
//   announcementList,
//   messageDetail,
//   nextmessageDetail,
//   briefList,
//   documentList,
//   selectAnnouncementList,
//   getTopNews
// } from '../config/apiUrl'
import API from '../services';
const { getNewsList, getHotNews, getNewsDetail, getSelectAnnouncementList, getNextNew, getTopNews,  getBriefList} = API.dataqin

const getData = async (params, _isBrowser) => {
  return new Promise(resolve => {
    announcementList(params, _isBrowser).then((result) => {
      const { total, records } = result
      resolve({
        record: result.records,
        total: result.total
      })
    })
  })
}


const getbriefList = async (params, _isBrowser) => {
  return new Promise(resolve => {
    briefList(params, _isBrowser).then((result) => {
      resolve({
        record: result.records
      })
    })
  })
}

const searchNewData = async(params,_isBrowser ) => {
  return new Promise(resolve => {
    selectAnnouncementList(params, _isBrowser).then((result) => {
      resolve({
        record: result
      })
    })
  })
}

// 获取新闻详情
const getnewdetail = async(params, _isBrowser) => {
  const { id, type } = params
  return new Promise(resolve => {
    messageDetail(params, _isBrowser).then((result) => {
      resolve({
        record: result
      })
    })
  })
}

// 下一条新闻
const getNextnewdetail = async(params) => {
  const { id } = params
  return new Promise(resolve => {
    nextmessageDetail(id).then((result) => {
      resolve({
        record: result
      })
    })
  })
}
// 获取置顶新闻列表
// const gettopnews = async(params, _isBrowser) => {
//   return new Promise(resolve => {
//     getTopNews(_isBrowser).then((result) => {
//       resolve({
//         topNew: result
//       })
//     })
//   })
// }


export default {
  namespace: 'news',
  state: {
    record: '',
    brieflist: '',
    topNew: [],
    hotnews: '',
    newDetail: {},
    isSearch: false,
    searchList: [],
    currentTitle: '',
    total: 0,
    newDetail: '',
    nextNew: '',
    currentPage: 1,
    currentBrifPage: 1,
    currentType: 0,
    noMore: false,
    isloading: false,
  },
  reducers: {
    initTop(state, { payload }) {
      return {
        ...state,
        topNew: payload
      }
    },
    updateDetail(state, { payload }) {
      return {
        ...state,
        newDetail: payload
      }
    },
    getnewlist(state, { payload, pageNum, total }) {
      if(pageNum > 1 && state.currentPage !== pageNum) {
        return {
          ...state,
          currentPage: pageNum,
          record: state.record.concat(payload)
        }
      }
      return {
        ...state,
        record: payload,
        total: total
      }
    },
    gethotnews(state, { payload }) {
      return {
        ...state,
        hotnews: payload
      }
    },
    getBrieflist(state, { payload, pageNum }) {
      let _state = state
      if(payload && payload.length === 0) {
        _state.noMore = true
      }
      if(pageNum === 1) {
        return {
          ..._state,
          currentBrifPage: pageNum,
          brieflist: payload,
          noMore: false
        }
      }
      if(state.currentBrifPage !== pageNum) {
        return {
          ..._state,
          currentBrifPage: pageNum,
          brieflist: state.brieflist.concat(payload)
        }
      }
    },
    getsearchList(state, { payload }) {
      return {
        ...state,
        searchList: payload
      }
    },
    setTitle(state, { title }) {
      const _state = JSON.parse(JSON.stringify(state)) // 必须得返回一个新的state 否则视图将不进行更新
      _state.currentTitle = title
      return _state
    },
    // 设置当前页面
    setCurrenPage(state, { page }) {
      const _state = JSON.parse(JSON.stringify(state)) // 必须得返回一个新的state 否则视图将不进行更新
      _state.currentPage = page
      return _state
    },
    // 设置当前类型
    setCurrenType(state, { currentType }) {
      const _state = JSON.parse(JSON.stringify(state)) // 必须得返回一个新的state 否则视图将不进行更新
      _state.currentType = currentType
      return _state
    },
    getnewDetail(state, { payload }) {
      return {
        ...state,
        newDetail: payload
      }
    },
    getnextNewDetail(state, { payload }) {
      return {
        ...state,
        nextNew: payload
      }
    },
    removesearch(state,{ payload }) {
      return {
        ...state,
        searchList: payload
      }
    },
    removelist(state) {
      let _state = state
      _state.record = []
      _state.total = 0
      return _state
      // return {
      //   ...state,
      //   record: '',
      //   total: 0
      // }
    },
    // loading处理
    isloading(state, { payload }) {
      return {
        ...state,
        isloading: payload
      }
    }
  },
  effects: {
    *setTopNew({ payload }, {put}) {
      yield put({
        type: 'initTop',
        payload: payload.topNew
       
      })
    },
    *setNewList({ payload }, {put}) {
      const data = payload.announcementList
      yield put({
        type: 'getnewlist',
        payload: data,
        pageNum: 1,
        total: data.total
      })
    },
    *setBriefList({ payload }, {put}) {
      yield put({
        type: 'getBrieflist',
        payload: payload.data,
        pageNum: 1
      })
    },
    *setHotNewList({ payload }, { put }) {
      const data = payload.announcementList
      yield put({
        type: 'gethotnews',
        payload: data.records
      })
    },
    *getTopNew({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getTopNews, payload)
      yield put({
        type: 'initTop',
        payload: data
       
      })
    },
    *getNewList({ payload, _isBrowser }, { call, put }) {
      // 先设置正在loading中
      yield put({
        type: 'isloading',
        payload: true
      })
      const data = yield call(getNewsList, payload, _isBrowser)
      yield put({
        type: 'isloading',
        payload: false
      })
      const { pageNum } = payload
      yield put({
        type: 'getnewlist',
        payload: data.records,
        pageNum,
        total: data.total
      })
    },
    *getHotNewList({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getHotNews, payload, _isBrowser)
      // 全部情况
      yield put({
        type: 'gethotnews',
        payload: data.records
      })
    },
    *getBriefList({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getBriefList, payload, _isBrowser)
      const { pageNum } = payload
      yield put({
        type: 'getBrieflist',
        payload: data.records,
        pageNum
      })
    },
    *updateNewDetail({ payload }, { put }) {
      yield put({
        type: 'updateDetail',
        payload
      })
    },
    // 清空searchlist
    *removeSearchList({ payload }, { put }) {
      yield put({
        type: 'removesearch',
        payload: []
      })
    },
    // 清空新闻列表
    *removeList({ payload }, { put }) {
      yield put({
        type: 'removelist'
      })
    },

    *searchNews({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getSelectAnnouncementList, payload, _isBrowser)
      // 全部情况
      yield put({
        type: 'getsearchList',
        payload: data
      })
    },
    // 设置搜索title
    *setNewTitle({ payload }, { put }) {
      yield put({
        type: "setTitle", // 调用上面的方法
        title: payload.title
      })
    },
    // 设置Type
    *setNewType({ payload }, { put }) {
      yield put({
        type: "setCurrenType", // 调用上面的方法
        currentType: payload.currentType
      })
    },
    // 设置CurrentPage
    *setNewCurrentPage({ payload }, { put }) {
      yield put({
        type: "setCurrenPage", // 调用上面的方法
        page: payload.page
      })
    },
    // 新闻详情
    *getNewDetail({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getNewsDetail, payload, _isBrowser)
      yield put({
        type: "getnewDetail", // 调用上面的方法
        payload: data
      })
    },
    // 下一条新闻
    *getNextNewDetail({ payload, _isBrowser }, { call, put }) {
      const data = yield call(getNextNew, payload, _isBrowser)
      // console.log(data)
      yield put({
        type: "getnextNewDetail", // 调用上面的方法
        payload: data
      })
    }
  }
}
